import _ from 'lodash';
import { getRevenueBasedLoanActiveRepaymentIDs } from '../../myAccount/multiLoanDashboard/accountsSelector';
import { getOpenBankingBanks, getTrueLayerBanks } from './SiteContextSelectors';
import { RootState } from '@iwProvider/configureStore';
import { GetOnlineAccountResponse } from '@iwoca/lapi-client/edge';

const getLatestOnlineAccount = (state: RootState) => {
    // Returns an array of IDs. Currently we only support a single repayment bank account so can take the 0th index as the API will only return one ID
    const hasActiveRepaymentIds = getRevenueBasedLoanActiveRepaymentIDs(state);

    const onlineAccounts: GetOnlineAccountResponse['data'] = _.get(
        state,
        'api.online_account.data'
    );

    if (!_.isEmpty(onlineAccounts) && !_.isEmpty(hasActiveRepaymentIds)) {
        const firstAccountWithRepaymentID = onlineAccounts.find(
            (onlineAccount) =>
                onlineAccount.accounts.find(
                    (subAccount) =>
                        subAccount.account_id === hasActiveRepaymentIds[0]
                )
        );

        return firstAccountWithRepaymentID;
    }

    return _.reduce(onlineAccounts, (a, b) => {
        return new Date(a.linked_at) > new Date(b.linked_at) ? a : b;
    });
};

export const isLatestOnlineAccountNotActive = (state: RootState) => {
    const latestOnlineAccounts = getLatestOnlineAccount(state);

    const statusCode = _.get(latestOnlineAccounts, 'status.code');
    if (statusCode !== OPEN_BANKING_STATUS.ACTIVE) return true;
};

export const OPEN_BANKING_STATUS = {
    ACTIVE: 'active',
    EXPIRED: 'expired'
};
export const getLatestOnlineAccountStatus = (state: RootState) => {
    const latestOnlineAccounts = getLatestOnlineAccount(state);

    return _.get(latestOnlineAccounts, 'status.code');
};

export const getLatestOnlineAccountExpiryDate = (state: RootState) => {
    const latestOnlineAccounts = getLatestOnlineAccount(state);

    return _.get(latestOnlineAccounts, 'expiry_at');
};

export const getLatestOnlineAccountProvider = (state: RootState) => {
    const latestOnlineAccounts = getLatestOnlineAccount(state);

    return _.get(latestOnlineAccounts, 'provider');
};

function getBankNameFromProvider(
    provider: string,
    openBankingProviders: { bank_name: string }[]
) {
    const accountBank = _.find(openBankingProviders, ['bank_name', provider]);

    if (accountBank) {
        return accountBank.bank_name;
    }
    return '';
}

export function getBankNameFromLatestOnlineAccount(state: RootState) {
    // Banks supported pre-truelayer
    const openBankingProviders = getOpenBankingBanks(state);
    const trueLayerBanks = getTrueLayerBanks(state);
    const provider = getLatestOnlineAccountProvider(state)!;

    const allOpenBankingBanks = [...openBankingProviders, ...trueLayerBanks];

    return getBankNameFromProvider(provider, allOpenBankingBanks);
}
